module.exports = __webpack_public_path__ + "static/media/aptoMedico.d41fc105.pdf";